import React from "react";
import VideoPlayerComponent from "../VideoPlayerComponent";

export default function Play() {
    return (
        <VideoPlayerComponent/>
    );
}
